import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as select from '../data/selector'
import ReCAPTCHA from "react-google-recaptcha"
import { Header, Input, Icon, Table, Form, Button,Label } from "semantic-ui-react";
import Group_724 from "../../../image/Group_724.png"
import Group_732 from "../../../image/Group_732.png"
import { Formik, Field, Form as FormikForm } from "formik";
import {FormikInputComponent} from "../../../utilities/formUtils";


const CompanyRegistration_one = (props) => {
    const isSaving = useSelector(state => select.isSaving(state,props));
    const onchangehandle = (e) =>{
        if(e.target.name=="comp_name"){
            props.setcompNameErrorclass("");
            props.setcustomCompNameErrorMsg("");
        }else if(e.target.name=="comp_short_name"){
            props.setcompSNameErrorclass("");
            props.setcustomCompSNameErrorMsg("");
        }
    }
    return (
        <div style={{display :props.displayparam}}>
            <div className="signUpContentContainer">
                <div className="chat-wrapper">
                    <div className="chat-head">
                        <h4>RealBooks Virtual Assistant</h4>
                    </div>
                    <div className="chat-boxes-wrap">
                        <div className="chat-box-rb">
                            <img src={Group_724} />
                            <p>Fill up your Registration details in 4 simple steps</p>
                        </div>
                        <div className="chat-box-rb">
                            <img src={Group_724} />
                            <p>Enter your Company's Trade Name.</p>
                        </div>
                        <div className="chat-box-user">
                            <p>Okay! What is Company's Short Name?</p>
                            <img src={Group_732} />
                        </div>
                        <div className="chat-box-rb-2">
                            <img src={Group_724} />
                            <p>Short name is the abbreviation or the brand name of your company. This is displayed at the Top Navigation Bar of your RealBooks Account.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="signUpFormContainer">
                <div className="signUpFormHelpContainerInner ">{/*signUpBigFormContainerInnerWidth*/}
                    <div className="sign-up-head">
                        <h3 className="signuptxt">Company Registration</h3>
                    </div>
                    <div className="progress-container">
                        <div className="progress" id="progress"></div>
                        <div className="circle green"></div>
                        <div className="circle green"></div>
                        <div className="circle active"></div>
                        <div className="circle"></div>
                        <div className="circle"></div>
                        <div className="circle"></div>
                    </div>
                    <div className="sign-up-form-info">
                        <Form.Group widths={2}>
                            <div className="mb-3">
                                <label for="Inputemail" className="sign-up-field-name form-label">Company Name</label>
                                <Field
                                    id="comp_name"
                                    name="comp_name"
                                    noLabel="y"
                                    component={FormikInputComponent}
                                    icontoShow = 'address card'
                                    iconPosition='left'
                                    placeholder = "Enter your company name"
                                    style={{marginTop:"11px"}}
                                    className={props.compNameErrorclass}
                                    myChangeFunction = {onchangehandle}
                                    iserror={props.compNameErrorclass != "" ? true : false}
                                    customErrorMsg = {props.customCompNameErrorMsg}
                                />
                            </div>
                        </Form.Group>
                        <Form.Group widths={2}>
                            <div className="mb-3 mb-4">
                                <label for="Inputemail" className="sign-up-field-name form-label">Company Short Name</label>
                                <Field
                                    id="comp_short_name"
                                    name="comp_short_name"
                                    noLabel="y"
                                    component={FormikInputComponent}
                                    icontoShow = 'address card'
                                    iconPosition='left'
                                    placeholder = "Add a short display name"
                                    style={{marginTop:"11px"}}
                                    className={props.compSNameErrorclass}
                                    myChangeFunction = {onchangehandle}
                                    iserror={props.compSNameErrorclass != "" ? true : false}
                                    customErrorMsg = {props.customCompSNameErrorMsg}
                                    maxLength={6}
                                />
                                <div className="otp-info">Maximum 6 characters</div>
                            </div>
                        </Form.Group>
                        <br/>
                        <Form.Group widths={2}>
                            {/* <Button
                                floated="left"
                                type="button"
                                size="medium"
                                // color="green"
                                className="btn-back"
                                onClick={props.clickBackBtn}
                                style={{ width: "94%", marginTop: "10px" }}
                            >Back</Button> */}
                            <Button
                                floated="left"
                                type="submit"
                                size="medium"
                                color="green"
                                className="btn-next"
                                // disabled = {isSaving ? true : false}                             
                                // loading = {isSaving ? true : false}  
                                style={{ width: "94%", marginTop: "10px" }}
                            >Next</Button>
                        </Form.Group>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default CompanyRegistration_one;